import type { FC } from 'react';
import { Box, TableCell, Typography } from '@mui/material';

import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

const ProjectNameCell: FC<CellProps> = ({ columns, survey }) => (
  <TableCell sx={styles.cell(columns.projectName.width)}>
    <Box>
      <Typography variant="body1" sx={styles.pill} title={survey.projectName}>
        {survey.projectName}
      </Typography>
    </Box>
  </TableCell>
);

export default ProjectNameCell;
